import { FEATURE_FLAGS, SKILL_LEVELS } from '@/constants';
import { cva } from 'class-variance-authority';

const isV2 = FEATURE_FLAGS.ENABLE_SCORECARD_V2;

/**
 * Base tag styles applied to all tag variants.
 * Matches Figma design with solid backgrounds, specific padding, and typography.
 */
export const baseTagStyles = [
  'cursor-inherit',
  'font-medium',
  'inline-flex',
  'items-center',
  'justify-center',
  'leading-4',
  'px-[9px]',
  'py-[3px]',
  'rounded-[6px]',
  'select-none',
  'text-[12px]',
  'text-black',
  'whitespace-nowrap',
].join(' ');

/**
 * Tag variants using class-variance-authority.
 * Each variant corresponds to a skill level with specific background colors
 * matching the Figma design system.
 */
export const tagVariants = cva(baseTagStyles, {
  variants: {
    variant: {
      // Canonical codes
      [SKILL_LEVELS.AWARENESS]: ['bg-semantic-score-l1'],
      [SKILL_LEVELS.SKILLED]: ['bg-semantic-score-l2'],
      [SKILL_LEVELS.ADVANCED]: ['bg-semantic-score-l3'],
      [SKILL_LEVELS.EXPERT]: ['bg-semantic-score-l4'],
      // Legacy aliases mapped to same colors as their canonical codes
      [SKILL_LEVELS.BEGINNER]: ['bg-semantic-score-legacy-l1'],
      [SKILL_LEVELS.INTERMEDIATE]: ['bg-semantic-score-legacy-l2'],
      [SKILL_LEVELS.NOVICE]: ['bg-semantic-score-legacy-l1'],
      // Non-skill-level variants
      ['pass']: ['bg-accent-surface-green'],
      ['fail']: isV2 ? ['bg-accent-surface-yellow'] : ['bg-accent-surface-red'],
      ['new']: ['text-neutral-white bg-neutral-black'],
      ['not attempted']: ['text-neutral-black bg-neutral-gray-100'],
      ['default']: ['bg-neutral-gray-400'],
      null: ['bg-neutral-gray-400'],
      undefined: ['bg-neutral-gray-400'],
    },
    withBorder: {
      true: ['border border-neutral-gray-800'],
      false: [],
    },
  },

  compoundVariants: [
    // Example of a compound variant: if we wanted a specific style for 'pass' variant with border
    // { variant: 'pass', withBorder: true, className: 'border-green-500' },
    {
      variant: 'fail',
      withBorder: true,
      className: isV2 ? 'border-accent-border-yellow' : 'border-accent-red-500',
    },
    {
      variant: 'pass',
      withBorder: true,
      className: 'border-accent-border-green',
    }
  ],

  // Default tag variant
  defaultVariants: {
    variant: 'default',
    withBorder: false,
  },
});
